<template>
  <b-container class="contendordepagina">
    <!-- {{ vuexAuthUsuario }} - {{ vuexNombreUsuario }} -->
    <div v-if="vuexAuthUsuario && vuexNombreUsuario.length">
      <b-jumbotron header="Gestión de firmas electrónicas" lead="Asistente para el envío de documentos a firmar mediante firma electrónica">
        <p>Bienvenido {{ vuexNombreUsuario }}</p>
        <p>Esta herramienta facilita la tarea de enviar documentos a firmar tanto a personas de Manusa, como externos. Además, permite hacer un seguimiento de los documentos enviados.</p>
        <div>
          Antes de empezar, es importante tener en cuenta que:
          <ul>
            <li>Los documentos a enviar deben estar en format PDF</li>
            <li>Las opciones de envío están personalizadas dependiendo del perfil de cada usuario</li>
            <li>Una firma electrónica valida el documento completo, independientemente de donde ésta esté insertada. Ya no es necesario firmar cada página.</li>
            <li>Todos los firmantes recibirán copia del documento firmado una vez se complete por todas las partes.</li>
            <li>Cualquier duda relacionada con la aplicación o el concepto de firma electrónica, consultar con Angel Ortega (angel.ortega@manusa.com)</li>
          </ul>
        </div>
      </b-jumbotron>
      <div class="text-center">
        <b-row>
          <b-col v-for="s in seccionesvisibles" :key="s.nombre" class="centrar">
            <b-link class="enlaceseccion" :href="s.enlace">
              <b-icon v-if="s.icono" :icon="s.icono" style="width: 120px; height: 120px" /><br />
              {{ s.texto }}
            </b-link>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else>
      <b-jumbotron class="alert-danger">
        <span class="font-weight-bold">¡No estás autenticado!</span><br />
        Para poder hacer uso de esta herramienta, debes acceder a través del
        <a href="//portal.manusa.com">Portal de empleado</a>
      </b-jumbotron>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      seccionesdisponibles: [
        {
          grupo: 'MISEFIRMA',
          texto: 'Mis efirma',
          nombre: 'listadodocumentos',
          icono: 'table',
          enlace: '/gestion-documentos-listado'
        },
        /*
        {
          grupo: 'ESPECIALES-CONSEJOADM',
          texto: 'Documentación Consejo de Administración',
          nombre: 'documentacionconsejoadministracion',
          icono: null,
          enlace: '/efirma-consejo-administracion'
        },
        {
          grupo: 'ESPECIALES-CONTRATOSNAC',
          texto: 'Contrato',
          nombre: 'contratos',
          icono: null,
          enlace: '/efirma-contratos'
        },
        {
          grupo: 'ESPECIALES-ACTACOMITETR',
          texto: 'Acta Comité de trabajadores',
          nombre: 'actacomitetrabajadores',
          icono: null,
          enlace: '/efirma-acta-comite-trabajadores'
        },
        */
        {
          grupo: 'SFY',
          texto: 'Solo firmo yo',
          nombre: 'soloyo',
          icono: 'person-circle',
          enlace: '/efirma-soloyo'
        },
        {
          grupo: 'FFVV',
          texto: 'Firman varios',
          nombre: 'firmanvarios',
          icono: 'people-fill',
          enlace: '/efirma-firmanvarios'
        }
      ],
      seccionesvisibles: []
    };
  },
  mounted() {
    this.inicializar();
  },
  methods: {
    inicializar() {
      // //console.log("this.$store.getters", this.$store.getters)
      // const tipologias = this.vuexTipologiasUsuario;
      // console.log("tipologias", tipologias, this.vuexTipologiasUsuario);
      const missecciones = this.$store.getters.misSecciones;
      console.log('missecciones', missecciones);
      this.seccionesvisibles = [];
      this.seccionesdisponibles.forEach((s) => {
        if (missecciones[0] === '*') {
          this.seccionesvisibles.push(s);
        } else {
          missecciones.forEach((t) => {
            if (s.grupo === t) this.seccionesvisibles.push(s);
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      vuexSeccion: 'seccion',
      vuexAuthUsuario: 'user/autenticado',
      vuexNombreUsuario: 'user/nombre',
      vuexTipologiasUsuario: 'user/tipologias'
    })
  }
};
</script>

<style scoped>
.btn-inverso,
a.btn-inverso:link,
a.btn-inverso:visited {
  color: var(--color-manusa-azul) !important;
  background-color: #fff !important;
}
.btn-inverso:hover,
a.btn-inverso:hover {
  color: #fff !important;
  background-color: var(--color-manusa-azul) !important;
  font-weight: normal !important;
}
.btn-circular {
  margin: 1em 0;
  border-radius: 7em;
  height: 8em;
  font-size: 1.5em;
}

.btn-ztactivo {
  color: rgb(206, 156, 20) !important;
  border-color: rgb(206, 156, 20) !important;
  font-weight: normal !important;
}
.zt {
  display: block;
  display: none;
}
.enlaceseccion {
  font-size: 1.5em;
  font-weight: 100;
  margin: 0 auto;
  text-decoration: none;
}
.enlaceseccion:hover {
  text-decoration: none;
  color: darkblue;
}
.centrar {
  display: flex;
  align-items: center;
}
</style>
